import React, { useState, useEffect, Fragment } from "react";
import UserService from "../services/user.service";
import EventBus from "../common/EventBus";
import { Table, Button, Container, Modal, Form, ButtonGroup, Pagination, Spinner } from 'react-bootstrap';
import { FaEdit, FaTrash } from 'react-icons/fa';
import ErrorModal from './ErrorModal';

const BoardMainVos = () => {
  const [mainvos, setMainVos] = useState([]);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedMainVos, setSelectedMainVos] = useState(null);
  const [deleteState, setDeleteState] = useState(false);
  const [errors, setErrors] = useState({});
  const [apierrors, setApiErrors] = useState('');
  const [filterTerm, setFilterTerm] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: 'main_vo_id', direction: 'asc' });
  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState(' Lade, bitte warten...');
  const [showModal, setShowModal] = useState(false);
  const [errorCode, setApiErrorCode] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10); // Items per page

  // NEW: State to track the expanded row
  const [expandedRowId, setExpandedRowId] = useState(null);

  const [formData, setFormData] = useState({
    company_name: "",
    company_mobile_number: "",
    company_email: "",
    contact_first_name: "",
    contact_last_name: "",
    contact_mobile_number: "",
    contact_email: "",
    street: "",
    city: "",
    state: "",
    postal_code: "",
    country: "",
    bank_name: "",
    bank_account_number: "",
    bank_swift_code: "",
    bank_iban: "",
    bank_address: "",
    company_registry: "",
    company_court: "",
    company_ceo: "",
    company_tax_number: "",
    company_vat_id: "",
  });

  const validateForm = () => {
    const newErrors = {};
  
    // Validate company_name
    if (!formData.company_name.trim()) {
      newErrors.company_name = 'Company Name is required';
    }
  
     // Validate contact_mobile_number (example: must be a valid phone number)
     if (!formData.company_mobile_number.trim()) {
      newErrors.company_mobile_number = 'Company Mobile Number is required';
    } else if (!/^(00\d{2,3}|0\d{4,}|(\+49)?\d{3,})\d{6,}$/g.test(formData.company_mobile_number)) {
      newErrors.company_mobile_number = 'Company Mobile Number must be a valid international phone number';
    }

   
  
    // Validate company_email (example: must be a valid email)
    if (!formData.company_email.trim()) {
      newErrors.company_email = 'Company Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.company_email)) {
      newErrors.company_email = 'Company Email must be a valid email address';
    }
  
    // Validate contact_first_name
    if (!formData.contact_first_name.trim()) {
      newErrors.contact_first_name = 'Contact First Name is required';
    }
  
    // Validate contact_last_name
    if (!formData.contact_last_name.trim()) {
      newErrors.contact_last_name = 'Contact Last Name is required';
    }
  
    // Validate contact_mobile_number (example: must be a valid phone number)
    if (!formData.contact_mobile_number.trim()) {
      newErrors.contact_mobile_number = 'Contact Mobile Number is required';
    }else if (!/^(00\d{2,3}|0\d{4,}|(\+49)?\d{3,})\d{6,}$/g.test(formData.contact_mobile_number)) {
      newErrors.contact_mobile_number = 'Contact Mobile Number must be a valid international phone number';
    }
    
  
    // Validate contact_email (example: must be a valid email)
    if (!formData.contact_email.trim()) {
      newErrors.contact_email = 'Contact Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.contact_email)) {
      newErrors.contact_email = 'Contact Email must be a valid email address';
    }

    // Address fields
    if (formData.street && !formData.street.trim()) {
      newErrors.street = 'Street is required if provided';
  }
  if (formData.city && !formData.city.trim()) {
      newErrors.city = 'City is required if provided';
  }
  if (formData.state && !formData.state.trim()) {
      newErrors.state = 'State is required if provided';
  }
  if (formData.postal_code && !/^\d{4,10}$/.test(formData.postal_code)) {
      newErrors.postal_code = 'Postal Code must be a valid number between 4 and 10 digits';
  }
  if (formData.country && !formData.country.trim()) {
      newErrors.country = 'Country is required if provided';
  }

  // Bank fields
  if (formData.bank_name && !formData.bank_name.trim()) {
      newErrors.bank_name = 'Bank Name is required if provided';
  }
  if (formData.bank_account_number && !/^\d{8,20}$/.test(formData.bank_account_number)) {
      newErrors.bank_account_number = 'Bank Account Number must be between 8 and 20 digits';
  }
  if (formData.bank_swift_code && !/^[A-Z0-9]{8,11}$/.test(formData.bank_swift_code)) {
      newErrors.bank_swift_code = 'SWIFT Code must be between 8 and 11 alphanumeric characters';
  }
  if (formData.bank_iban && !/^[A-Z0-9]{15,34}$/.test(formData.bank_iban)) {
      newErrors.bank_iban = 'IBAN must be between 15 and 34 alphanumeric characters';
  }
  if (formData.bank_address && !formData.bank_address.trim()) {
      newErrors.bank_address = 'Bank Address is required if provided';
  }


    console.log(newErrors);
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };
  
  
  useEffect(() => {
    validateForm();
  }, [formData]); // This will run every time formData is updated



  useEffect(() => {
    
    UserService.getMainVosBoard().then(
      (response) => {
        setMainVos(response.data);
       
      }).catch((error) => {
        console.log(error);
        console.log(error.message);
        const _content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
          console.log(_content);
          if (error.response) {
            // Server responded with a status other than 200 range
            setApiErrors(`Error: ${error.name} - ${error.response.data.message}-${error.code}`);
            setApiErrorCode(`Error: ${error.name} - ${error.code}`);
          } else if (error.request) {
            // Request was made, but no response was received
            setApiErrors('Error: No response received from the server.');
            setApiErrorCode(`Error: ${error.name} - ${error.code}`);
          } else {
            // Other types of errors
            setApiErrors(`Error: ${error.response.data.message}`);
            setApiErrorCode(`Error: ${error.name} - ${error.code}`);
          } 
        setMainVos(_content);

        if (error.response && error.response.status === 401) {
          EventBus.dispatch("logout");
        }
        
      
});
  }, [deleteState]);
  
 
  const filteredMainVOs = Array.isArray(mainvos)
  ? mainvos.filter((vo) =>
      // Existing fields
      (vo.company_name && vo.company_name.toLowerCase().includes(filterTerm.toLowerCase())) ||
      (vo.company_mobile_number && vo.company_mobile_number.includes(filterTerm)) ||
      (vo.company_email && vo.company_email.toLowerCase().includes(filterTerm.toLowerCase())) ||
      (vo.contact_first_name && vo.contact_first_name.toLowerCase().includes(filterTerm.toLowerCase())) ||
      (vo.contact_last_name && vo.contact_last_name.toLowerCase().includes(filterTerm.toLowerCase())) ||
      (vo.contact_mobile_number && vo.contact_mobile_number.includes(filterTerm)) ||
      (vo.contact_email && vo.contact_email.toLowerCase().includes(filterTerm.toLowerCase())) ||
      (vo.rec_date && vo.rec_date.includes(filterTerm)) ||

      // New fields for filtering
      (vo.street && vo.street.toLowerCase().includes(filterTerm.toLowerCase())) ||
      (vo.city && vo.city.toLowerCase().includes(filterTerm.toLowerCase())) ||
      (vo.state && vo.state.toLowerCase().includes(filterTerm.toLowerCase())) ||
      (vo.postal_code && vo.postal_code.includes(filterTerm)) ||
      (vo.country && vo.country.toLowerCase().includes(filterTerm.toLowerCase())) ||
      (vo.bank_name && vo.bank_name.toLowerCase().includes(filterTerm.toLowerCase())) ||
      (vo.bank_account_number && vo.bank_account_number.includes(filterTerm)) ||
      (vo.bank_swift_code && vo.bank_swift_code.toLowerCase().includes(filterTerm.toLowerCase())) ||
      (vo.bank_iban && vo.bank_iban.toLowerCase().includes(filterTerm.toLowerCase())) ||
      (vo.bank_address && vo.bank_address.toLowerCase().includes(filterTerm.toLowerCase()))
  )
  : [];


 // Handle pagination
const handlePageChange = (pageNumber) => {
  setCurrentPage(pageNumber);
};

// Sorting function
const handleSort = (key) => {
  let direction = 'asc';
  if (sortConfig.key === key && sortConfig.direction === 'asc') {
    direction = 'desc';
  }
  setSortConfig({ key, direction });
};



const sortedMainVOs = [...filteredMainVOs].sort((a, b) => {
  let aValue, bValue;

  // Handle nested properties for sorting
  if (sortConfig.key === 't_areas.area_id') {
    aValue = a.t_areas?.area_id || '';
    bValue = b.t_areas?.area_id || '';
  }  else {
    // For non-nested keys
    aValue = a[sortConfig.key];
    bValue = b[sortConfig.key];
  }

  // Perform the comparison based on direction
  if (aValue < bValue) {
    return sortConfig.direction === 'asc' ? -1 : 1;
  }
  if (aValue > bValue) {
    return sortConfig.direction === 'asc' ? 1 : -1;
  }
  return 0;
});


// Get the current page's data
const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;
const currentMainVOs = sortedMainVOs.slice(indexOfFirstItem, indexOfLastItem);

// Total pages calculation
const totalPages = Math.ceil(sortedMainVOs.length / itemsPerPage);

  const handleEditClick = (main_vo) => {
    setApiErrors(null);
    setApiErrorCode(null);
    setSelectedMainVos(main_vo);
    setFormData(main_vo);
    setShowEditModal(true);
  };

  const handleCreateClick = () => {
    setApiErrors(null);
    setApiErrorCode(null);
    setFormData({
      company_name: "",
      company_mobile_number: "",
      company_email: "",
      contact_first_name: "",
      contact_last_name: "",
      contact_mobile_number: "",
      contact_email: "",
      street: "",
      city: "",
      state: "",
      postal_code: "",
      country: "",
      bank_name: "",
      bank_account_number: "",
      bank_swift_code: "",
      bank_iban: "",
      bank_address: "",
      company_registry: "",
      company_court: "",
      company_ceo: "",
      company_tax_number: "",
      company_vat_id: "",
    });
    setShowCreateModal(true);
  };


  const isValidDate = (date) => {
    return !isNaN(Date.parse(date));
  };

  const handleDeleteClick = async (id,e) => {
    e.preventDefault();
    setApiErrors(null);
    setApiErrorCode(null);
    try {
      setLoadingText('Daten werden gelöscht, bitte warten...');
      setLoading(true);
      await UserService.deleteMainVosBoard(id);
      setDeleteState(prev => !prev);
      console.info(deleteState);
    } catch (error) {
      setApiErrors(`Error: ${error.name}-${error.code} - ${error.response.data.message}-${error.response.data.error}`);
      setApiErrorCode(`Error: ${error.name} - ${error.code}`);
      setShowModal(true);
      console.error('Error deleting Main VO:', error);
      setShowModal(true);
    }
    finally {
      setLoading(false);
    }
  };

  const handleEditSubmit = async (e) => {
    console.log(formData);
    console.log(selectedMainVos);
    e.preventDefault();
    if (!validateForm()) return; 
    try {
      setLoadingText('Daten werden aktualisiert, bitte warten...');
      setLoading(true);
      // formData.rec_date = new Date();
      await UserService.updateMainVosBoard(selectedMainVos.main_vo_id,formData);
      setDeleteState(prev => !prev);
      setShowEditModal(false);
    } catch (error) {
      setApiErrors(`Error: ${error.name} - ${error.response.data.message}-${error.code}`);
      setApiErrorCode(`Error: ${error.name} - ${error.code}`);
      console.error('Error creating Main VO:', error);
      setShowModal(true);
    }
    finally {
      setLoading(false);
    }
  };

  


  const handleCreateSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return; 
    try {
      setLoadingText('Daten werden erstellt, bitte warten...');
      setLoading(true);
      formData.rec_date = new Date();
      const recDate = formData.rec_date;
      const validDate = isValidDate(recDate) ? recDate : null;     
      formData.rec_date = validDate;
      await UserService.createMainVosBoard(formData);
      setDeleteState(prev => !prev);
      setShowCreateModal(false);
      
    } catch (error) {
      setApiErrors(`Error: ${error.name} - ${error.response.data.message}-${error.code}`);
      setApiErrorCode(`Error: ${error.name} - ${error.code}`);
      console.error('Error creating Main VO:', error);
      setShowModal(true);
    }
    finally {
      setLoading(false);
    }
  };

  const handleBlur = () => {
    validateForm();
 };

 const handleChange = (e) => {
   // Ankreuzfelder liefern ihren Wert ueber `checked`, Textfelder ueber `value`.
   const nextValue = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
   setFormData({
     ...formData,
     [e.target.name]: nextValue
   });
 validateForm();
 };

 // NEW: Function to toggle the expanded row
  const handleToggleDetails = (voId) => {
    setExpandedRowId(expandedRowId === voId ? null : voId);
  };

  const handleCloseModal = () => setShowModal(false);

  return (
    <Container>
      <h1 className="mt-5">Haupt-VO Übersicht</h1>
      <ErrorModal show={showModal} handleClose={handleCloseModal} errorCode={errorCode} errorMessage={apierrors} />
      <Button variant="info" onClick={handleCreateClick} className="mr-2 mb-2">
        Erstellen
      </Button>
      {loading && (
        <div className="spinner-overlay">
         <div className="spinner-background">
          <Spinner animation="border" role="status" className="spinner-border">
            <span className="sr-only">Lade...</span>
          </Spinner>
          <div className="spinner-text">...{loadingText}</div>
          </div>
        </div>
      )}
      <Form.Group controlId="formBasicSearch">
        <Form.Control
          type="text"
          placeholder="Suchen..."
          value={filterTerm}
          onChange={(e) => setFilterTerm(e.target.value)}
        />
      </Form.Group>

      {/* ==================================================================== */}
      {/* NEW, CLEANED UP TABLE                                                */}
      {/* ==================================================================== */}
      <Table striped bordered hover responsive className="mt-4">
        <thead>
          <tr>
            <th onClick={() => handleSort('main_vo_id')} style={{ cursor: 'pointer' }}>
              ID {sortConfig.key === 'main_vo_id' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('company_name')} style={{ cursor: 'pointer' }}>
              Firmenname {sortConfig.key === 'company_name' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('contact_first_name')} style={{ cursor: 'pointer' }}>
              Ansprechpartner {sortConfig.key === 'contact_first_name' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('company_email')} style={{ cursor: 'pointer' }}>
              Firmen-E-Mail {sortConfig.key === 'company_email' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('city')} style={{ cursor: 'pointer' }}>
              Stadt {sortConfig.key === 'city' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th>Aktionen</th>
          </tr>
        </thead>
        <tbody>
          {currentMainVOs.map((vo) => (
            <Fragment key={vo.main_vo_id}>
              <tr>
                <td>{vo.main_vo_id}</td>
                <td>{vo.company_name}</td>
                <td>{vo.contact_first_name} {vo.contact_last_name}</td>
                <td>{vo.company_email}</td>
                <td>{vo.city}</td>
                <td>
                  <ButtonGroup>
                    <Button variant="secondary" size="sm" onClick={() => handleToggleDetails(vo.main_vo_id)}>
                      {expandedRowId === vo.main_vo_id ? 'Schließen' : 'Details'}
                    </Button>
                    <Button variant="warning" size="sm" onClick={() => handleEditClick(vo)} className="ml-2" title="Bearbeiten" aria-label="Bearbeiten">
                      <FaEdit />
                    </Button>
                    <Button variant="danger" size="sm" onClick={(e) => handleDeleteClick(vo.main_vo_id, e)} className="ml-2" title="Löschen" aria-label="Löschen">
                      <FaTrash />
                    </Button>
                  </ButtonGroup>
                </td>
              </tr>
              {/* --- EXPANDABLE ROW FOR DETAILS --- */}
              {expandedRowId === vo.main_vo_id && (
                <tr className="table-details">
                  <td colSpan="6">
                    <div style={{ padding: '10px' }}>
                      <h5>Details für: {vo.company_name}</h5>
                      <p><strong>Firmen-Mobil:</strong> {vo.company_mobile_number}</p>
                      <p><strong>Kontakt Mobil:</strong> {vo.contact_mobile_number}</p>
                      <p><strong>Kontakt E-Mail:</strong> {vo.contact_email}</p>
                      <hr />
                      <p><strong>Adresse:</strong> {vo.street}, {vo.postal_code} {vo.city}, {vo.state}, {vo.country}</p>
                      <hr />
                      <p><strong>Bankname:</strong> {vo.bank_name}</p>
                      <p><strong>IBAN:</strong> {vo.bank_iban}</p>
                      <p><strong>SWIFT:</strong> {vo.bank_swift_code}</p>
                      <p><strong>Kontonummer:</strong> {vo.bank_account_number}</p>
                      <p><strong>Bankadresse:</strong> {vo.bank_address}</p>
                      <hr />
                      <p><strong>Handelsregister:</strong> {vo.company_registry}</p>
                      <p><strong>Registergericht:</strong> {vo.company_court}</p>
                      <p><strong>Geschäftsführer:</strong> {vo.company_ceo}</p>
                      <p><strong>Steuernummer:</strong> {vo.company_tax_number}</p>
                      <p><strong>USt-IdNr.:</strong> {vo.company_vat_id}</p>
                       <p><strong>Registrierungsdatum:</strong> {vo.rec_date}</p>
                    </div>
                  </td>
                </tr>
              )}
            </Fragment>
          ))}
        </tbody>
      </Table>
      
      <Pagination>
        <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
        <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
        {[...Array(totalPages)].map((_, index) => (
          <Pagination.Item
            key={index + 1}
            active={index + 1 === currentPage}
            onClick={() => handlePageChange(index + 1)}
          >
            {index + 1}
          </Pagination.Item>
        ))}
        <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
        <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
      </Pagination>

      {/* Create Modal */}
      <Modal show={showCreateModal} onHide={() => setShowCreateModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Neue Haupt-VO erstellen</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleCreateSubmit}>
            <Form.Group controlId="formCompanyName">
              <Form.Label>Firmenname</Form.Label>
              <Form.Control
                type="text"
                placeholder="Firmenname eingeben"
                name="company_name"
                value={formData.company_name}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.company_name}
              />
              <Form.Control.Feedback type="invalid">
                {errors.company_name}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formCompanyMobile">
              <Form.Label>Firmen-Mobilnummer</Form.Label>
              <Form.Control
                type="text"
                placeholder="Mobilnummer der Firma eingeben"
                name="company_mobile_number"
                value={formData.company_mobile_number}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.company_mobile_number}
              />
              <Form.Control.Feedback type="invalid">
                {errors.company_mobile_number}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formCompanyEmail">
              <Form.Label>Firmen-E-Mail</Form.Label>
              <Form.Control
                type="email"
                placeholder="E-Mail der Firma eingeben"
                name="company_email"
                value={formData.company_email}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.company_email}
              />
              <Form.Control.Feedback type="invalid">
                {errors.company_email}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formContactFirstName">
              <Form.Label>Kontakt Vorname</Form.Label>
              <Form.Control
                type="text"
                placeholder="Vornamen des Kontakts eingeben"
                name="contact_first_name"
                value={formData.contact_first_name}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.contact_first_name}
              />
              <Form.Control.Feedback type="invalid">
                {errors.contact_first_name}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formContactLastName">
              <Form.Label>Kontakt Nachname</Form.Label>
              <Form.Control
                type="text"
                placeholder="Nachnamen des Kontakts eingeben"
                name="contact_last_name"
                value={formData.contact_last_name}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.contact_last_name}
              />
              <Form.Control.Feedback type="invalid">
                {errors.contact_last_name}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formContactMobile">
              <Form.Label>Kontakt Mobilnummer</Form.Label>
              <Form.Control
                type="text"
                placeholder="Mobilnummer des Kontakts eingeben"
                name="contact_mobile_number"
                value={formData.contact_mobile_number}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.contact_mobile_number}
              />
              <Form.Control.Feedback type="invalid">
                {errors.contact_mobile_number}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formContactEmail">
              <Form.Label>Kontakt E-Mail</Form.Label>
              <Form.Control
                type="email"
                placeholder="E-Mail des Kontakts eingeben"
                name="contact_email"
                value={formData.contact_email}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.contact_email}
              />
              <Form.Control.Feedback type="invalid">
                {errors.contact_email}
              </Form.Control.Feedback>
              <Form.Group controlId="formStreet">
  <Form.Label>Straße</Form.Label>
  <Form.Control
    type="text"
    placeholder="Straße eingeben"
    name="street"
    value={formData.street}
    onChange={handleChange}
    onBlur={handleBlur}
    isInvalid={!!errors.street}
  />
  <Form.Control.Feedback type="invalid">
    {errors.street}
  </Form.Control.Feedback>
</Form.Group>

<Form.Group controlId="formCity">
  <Form.Label>Stadt</Form.Label>
  <Form.Control
    type="text"
    placeholder="Stadt eingeben"
    name="city"
    value={formData.city}
    onChange={handleChange}
    onBlur={handleBlur}
    isInvalid={!!errors.city}
  />
  <Form.Control.Feedback type="invalid">
    {errors.city}
  </Form.Control.Feedback>
</Form.Group>

<Form.Group controlId="formState">
  <Form.Label>Bundesland</Form.Label>
  <Form.Control
    type="text"
    placeholder="Bundesland eingeben"
    name="state"
    value={formData.state}
    onChange={handleChange}
    onBlur={handleBlur}
    isInvalid={!!errors.state}
  />
  <Form.Control.Feedback type="invalid">
    {errors.state}
  </Form.Control.Feedback>
</Form.Group>

<Form.Group controlId="formPostalCode">
  <Form.Label>PLZ</Form.Label>
  <Form.Control
    type="text"
    placeholder="PLZ eingeben"
    name="postal_code"
    value={formData.postal_code}
    onChange={handleChange}
    onBlur={handleBlur}
    isInvalid={!!errors.postal_code}
  />
  <Form.Control.Feedback type="invalid">
    {errors.postal_code}
  </Form.Control.Feedback>
</Form.Group>

<Form.Group controlId="formCountry">
  <Form.Label>Land</Form.Label>
  <Form.Control
    type="text"
    placeholder="Land eingeben"
    name="country"
    value={formData.country}
    onChange={handleChange}
    onBlur={handleBlur}
    isInvalid={!!errors.country}
  />
  <Form.Control.Feedback type="invalid">
    {errors.country}
  </Form.Control.Feedback>
</Form.Group>

<Form.Group controlId="formBankName">
  <Form.Label>Bankname</Form.Label>
  <Form.Control
    type="text"
    placeholder="Bankname eingeben"
    name="bank_name"
    value={formData.bank_name}
    onChange={handleChange}
    onBlur={handleBlur}
    isInvalid={!!errors.bank_name}
  />
  <Form.Control.Feedback type="invalid">
    {errors.bank_name}
  </Form.Control.Feedback>
</Form.Group>

<Form.Group controlId="formBankAccountNumber">
  <Form.Label>Kontonummer</Form.Label>
  <Form.Control
    type="text"
    placeholder="Kontonummer eingeben"
    name="bank_account_number"
    value={formData.bank_account_number}
    onChange={handleChange}
    onBlur={handleBlur}
    isInvalid={!!errors.bank_account_number}
  />
  <Form.Control.Feedback type="invalid">
    {errors.bank_account_number}
  </Form.Control.Feedback>
</Form.Group>

<Form.Group controlId="formBankSwiftCode">
  <Form.Label>SWIFT-Code</Form.Label>
  <Form.Control
    type="text"
    placeholder="SWIFT-Code eingeben"
    name="bank_swift_code"
    value={formData.bank_swift_code}
    onChange={handleChange}
    onBlur={handleBlur}
    isInvalid={!!errors.bank_swift_code}
  />
  <Form.Control.Feedback type="invalid">
    {errors.bank_swift_code}
  </Form.Control.Feedback>
</Form.Group>

<Form.Group controlId="formBankIBAN">
  <Form.Label>IBAN</Form.Label>
  <Form.Control
    type="text"
    placeholder="IBAN eingeben"
    name="bank_iban"
    value={formData.bank_iban}
    onChange={handleChange}
    onBlur={handleBlur}
    isInvalid={!!errors.bank_iban}
  />
  <Form.Control.Feedback type="invalid">
    {errors.bank_iban}
  </Form.Control.Feedback>
</Form.Group>

<Form.Group controlId="formBankAddress">
  <Form.Label>Bankadresse</Form.Label>
  <Form.Control
    type="text"
    placeholder="Bankadresse eingeben"
    name="bank_address"
    value={formData.bank_address}
    onChange={handleChange}
    onBlur={handleBlur}
    isInvalid={!!errors.bank_address}
  />
  <Form.Control.Feedback type="invalid">
    {errors.bank_address}
  </Form.Control.Feedback>
</Form.Group>


            </Form.Group>
            <Form.Group controlId="formCompanyRegistry">
        <Form.Label>Handelsregister</Form.Label>
        <Form.Control
          type="text"
          placeholder="Handelsregister eingeben"
          name="company_registry"
          value={formData.company_registry}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={!!errors.company_registry}
        />
        <Form.Control.Feedback type="invalid">
          {errors.company_registry}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group controlId="formCompanyCourt">
        <Form.Label>Registergericht</Form.Label>
        <Form.Control
          type="text"
          placeholder="Registergericht eingeben"
          name="company_court"
          value={formData.company_court}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={!!errors.company_court}
        />
        <Form.Control.Feedback type="invalid">
          {errors.company_court}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group controlId="formCompanyCEO">
        <Form.Label>Geschäftsführer</Form.Label>
        <Form.Control
          type="text"
          placeholder="Geschäftsführer eingeben"
          name="company_ceo"
          value={formData.company_ceo}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={!!errors.company_ceo}
        />
        <Form.Control.Feedback type="invalid">
          {errors.company_ceo}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group controlId="formCompanyTaxNumber">
        <Form.Label>Steuernummer</Form.Label>
        <Form.Control
          type="text"
          placeholder="Steuernummer eingeben"
          name="company_tax_number"
          value={formData.company_tax_number}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={!!errors.company_tax_number}
        />
        <Form.Control.Feedback type="invalid">
          {errors.company_tax_number}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group controlId="formCompanyVATID">
        <Form.Label>Umsatzsteuer-ID</Form.Label>
        <Form.Control
          type="text"
          placeholder="Umsatzsteuer-ID eingeben"
          name="company_vat_id"
          value={formData.company_vat_id}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={!!errors.company_vat_id}
        />
        <Form.Control.Feedback type="invalid">
          {errors.company_vat_id}
        </Form.Control.Feedback>
      </Form.Group>

            <Button variant="primary" type="submit" className="mt-3" disabled={loading}>
             {loading ? 'Wird gespeichert...' : 'Haupt-VO speichern'}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Edit Modal */}
      <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Haupt-VO bearbeiten</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleEditSubmit}>
            <Form.Group controlId="formCompanyName">
              <Form.Label>Firmenname</Form.Label>
              <Form.Control
                type="text"
                placeholder="Firmenname eingeben"
                name="company_name"
                value={formData.company_name}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.company_name}
              />
              <Form.Control.Feedback type="invalid">
                {errors.company_name}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formCompanyMobile">
              <Form.Label>Firmen-Mobilnummer</Form.Label>
              <Form.Control
                type="text"
                placeholder="Mobilnummer der Firma eingeben"
                name="company_mobile_number"
                value={formData.company_mobile_number}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.company_mobile_number}
              />
              <Form.Control.Feedback type="invalid">
                {errors.company_mobile_number}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formCompanyEmail">
              <Form.Label>Firmen-E-Mail</Form.Label>
              <Form.Control
                type="email"
                placeholder="E-Mail der Firma eingeben"
                name="company_email"
                value={formData.company_email}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.company_email}
              />
              <Form.Control.Feedback type="invalid">
                {errors.company_email}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formContactFirstName">
              <Form.Label>Kontakt Vorname</Form.Label>
              <Form.Control
                type="text"
                placeholder="Vornamen des Kontakts eingeben"
                name="contact_first_name"
                value={formData.contact_first_name}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.contact_first_name}
              />
              <Form.Control.Feedback type="invalid">
                {errors.contact_first_name}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formContactLastName">
              <Form.Label>Kontakt Nachname</Form.Label>
              <Form.Control
                type="text"
                placeholder="Nachnamen des Kontakts eingeben"
                name="contact_last_name"
                value={formData.contact_last_name}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.contact_last_name}
              />
              <Form.Control.Feedback type="invalid">
                {errors.contact_last_name}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formContactMobile">
              <Form.Label>Kontakt Mobilnummer</Form.Label>
              <Form.Control
                type="text"
                placeholder="Mobilnummer des Kontakts eingeben"
                name="contact_mobile_number"
                value={formData.contact_mobile_number}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.contact_mobile_number}
              />
              <Form.Control.Feedback type="invalid">
                {errors.contact_mobile_number}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formContactEmail">
              <Form.Label>Kontakt E-Mail</Form.Label>
              <Form.Control
                type="email"
                placeholder="E-Mail des Kontakts eingeben"
                name="contact_email"
                value={formData.contact_email}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.contact_email}
              />
              <Form.Control.Feedback type="invalid">
                {errors.contact_email}
              </Form.Control.Feedback>
              <Form.Group controlId="formStreet">
  <Form.Label>Straße</Form.Label>
  <Form.Control
    type="text"
    placeholder="Straße eingeben"
    name="street"
    value={formData.street}
    onChange={handleChange}
    onBlur={handleBlur}
    isInvalid={!!errors.street}
  />
  <Form.Control.Feedback type="invalid">
    {errors.street}
  </Form.Control.Feedback>
</Form.Group>

<Form.Group controlId="formCity">
  <Form.Label>Stadt</Form.Label>
  <Form.Control
    type="text"
    placeholder="Stadt eingeben"
    name="city"
    value={formData.city}
    onChange={handleChange}
    onBlur={handleBlur}
    isInvalid={!!errors.city}
  />
  <Form.Control.Feedback type="invalid">
    {errors.city}
  </Form.Control.Feedback>
</Form.Group>

<Form.Group controlId="formState">
  <Form.Label>Bundesland</Form.Label>
  <Form.Control
    type="text"
    placeholder="Bundesland eingeben"
    name="state"
    value={formData.state}
    onChange={handleChange}
    onBlur={handleBlur}
    isInvalid={!!errors.state}
  />
  <Form.Control.Feedback type="invalid">
    {errors.state}
  </Form.Control.Feedback>
</Form.Group>

<Form.Group controlId="formPostalCode">
  <Form.Label>PLZ</Form.Label>
  <Form.Control
    type="text"
    placeholder="PLZ eingeben"
    name="postal_code"
    value={formData.postal_code}
    onChange={handleChange}
    onBlur={handleBlur}
    isInvalid={!!errors.postal_code}
  />
  <Form.Control.Feedback type="invalid">
    {errors.postal_code}
  </Form.Control.Feedback>
</Form.Group>

<Form.Group controlId="formCountry">
  <Form.Label>Land</Form.Label>
  <Form.Control
    type="text"
    placeholder="Land eingeben"
    name="country"
    value={formData.country}
    onChange={handleChange}
    onBlur={handleBlur}
    isInvalid={!!errors.country}
  />
  <Form.Control.Feedback type="invalid">
    {errors.country}
  </Form.Control.Feedback>
</Form.Group>

<Form.Group controlId="formBankName">
  <Form.Label>Bankname</Form.Label>
  <Form.Control
    type="text"
    placeholder="Bankname eingeben"
    name="bank_name"
    value={formData.bank_name}
    onChange={handleChange}
    onBlur={handleBlur}
    isInvalid={!!errors.bank_name}
  />
  <Form.Control.Feedback type="invalid">
    {errors.bank_name}
  </Form.Control.Feedback>
</Form.Group>

<Form.Group controlId="formBankAccountNumber">
  <Form.Label>Kontonummer</Form.Label>
  <Form.Control
    type="text"
    placeholder="Kontonummer eingeben"
    name="bank_account_number"
    value={formData.bank_account_number}
    onChange={handleChange}
    onBlur={handleBlur}
    isInvalid={!!errors.bank_account_number}
  />
  <Form.Control.Feedback type="invalid">
    {errors.bank_account_number}
  </Form.Control.Feedback>
</Form.Group>

<Form.Group controlId="formBankSwiftCode">
  <Form.Label>SWIFT-Code</Form.Label>
  <Form.Control
    type="text"
    placeholder="SWIFT-Code eingeben"
    name="bank_swift_code"
    value={formData.bank_swift_code}
    onChange={handleChange}
    onBlur={handleBlur}
    isInvalid={!!errors.bank_swift_code}
  />
  <Form.Control.Feedback type="invalid">
    {errors.bank_swift_code}
  </Form.Control.Feedback>
</Form.Group>

<Form.Group controlId="formBankIBAN">
  <Form.Label>IBAN</Form.Label>
  <Form.Control
    type="text"
    placeholder="IBAN eingeben"
    name="bank_iban"
    value={formData.bank_iban}
    onChange={handleChange}
    onBlur={handleBlur}
    isInvalid={!!errors.bank_iban}
  />
  <Form.Control.Feedback type="invalid">
    {errors.bank_iban}
  </Form.Control.Feedback>
</Form.Group>

<Form.Group controlId="formBankAddress">
  <Form.Label>Bankadresse</Form.Label>
  <Form.Control
    type="text"
    placeholder="Bankadresse eingeben"
    name="bank_address"
    value={formData.bank_address}
    onChange={handleChange}
    onBlur={handleBlur}
    isInvalid={!!errors.bank_address}
  />
  <Form.Control.Feedback type="invalid">
    {errors.bank_address}
  </Form.Control.Feedback>
</Form.Group>

            </Form.Group>

            <Form.Group controlId="formCompanyRegistry">
        <Form.Label>Handelsregister</Form.Label>
        <Form.Control
          type="text"
          placeholder="Handelsregister eingeben"
          name="company_registry"
          value={formData.company_registry}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={!!errors.company_registry}
        />
        <Form.Control.Feedback type="invalid">
          {errors.company_registry}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group controlId="formCompanyCourt">
        <Form.Label>Registergericht</Form.Label>
        <Form.Control
          type="text"
          placeholder="Registergericht eingeben"
          name="company_court"
          value={formData.company_court}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={!!errors.company_court}
        />
        <Form.Control.Feedback type="invalid">
          {errors.company_court}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group controlId="formCompanyCEO">
        <Form.Label>Geschäftsführer</Form.Label>
        <Form.Control
          type="text"
          placeholder="Geschäftsführer eingeben"
          name="company_ceo"
          value={formData.company_ceo}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={!!errors.company_ceo}
        />
        <Form.Control.Feedback type="invalid">
          {errors.company_ceo}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group controlId="formCompanyTaxNumber">
        <Form.Label>Steuernummer</Form.Label>
        <Form.Control
          type="text"
          placeholder="Steuernummer eingeben"
          name="company_tax_number"
          value={formData.company_tax_number}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={!!errors.company_tax_number}
        />
        <Form.Control.Feedback type="invalid">
          {errors.company_tax_number}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group controlId="formCompanyVATID">
        <Form.Label>Umsatzsteuer-ID</Form.Label>
        <Form.Control
          type="text"
          placeholder="Umsatzsteuer-ID eingeben"
          name="company_vat_id"
          value={formData.company_vat_id}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={!!errors.company_vat_id}
        />
        <Form.Control.Feedback type="invalid">
          {errors.company_vat_id}
        </Form.Control.Feedback>
      </Form.Group>

      {/* Eigentuemer der selbst registrierten Kunden. Genau ein Haupt-VO darf
          gekennzeichnet sein; der Server entfernt die Kennzeichnung bei allen
          uebrigen automatisch. */}
      <Form.Group controlId="formSelfServiceHost" className="mt-3">
        <Form.Check
          type="checkbox"
          name="is_selfservice_host"
          checked={!!formData.is_selfservice_host}
          onChange={handleChange}
          label="Eigentümer der selbst registrierten Kunden"
        />
        <Form.Text muted>
          Kunden, die sich über die öffentliche Website selbst registrieren,
          werden diesem Haupt-VO zugeordnet. Es kann immer nur ein Haupt-VO
          gekennzeichnet sein. Ohne Kennzeichnung bleibt die Selbstregistrierung
          abgeschaltet.
        </Form.Text>
      </Form.Group>

            <Button variant="primary" type="submit" className="mt-3"disabled={loading}>
            {loading ? 'Aktualisieren...' : 'Haupt-VO aktualisieren'}
            </Button>
            
          </Form>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default BoardMainVos;